<template>
  <vs-popup
    class="qr-code-dialog"
    :title="$t('view_qr_code')"
    :active.sync="isDialogShow"
    color="#FE5924"
  >
    <div class="qr-code-content">
      <el-image
        :src="qrCodeUrl"
        :preview-src-list="[qrCodeUrl]"
        fit="contain"
        style="width: 220px;"
      ></el-image>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'QrCodeDialog',
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    qrCodeUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isDialogShow: this.dialogShow
    }
  },
  watch: {
    dialogShow(newVal) {
      this.isDialogShow = newVal;
    },
    isDialogShow(newVal) {
      if (!newVal) {
        this.$emit('close');
      }
    }
  }
}
</script>

<style scoped>
.qr-code-content {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}
</style>